import { z } from "zod";

/**
 * How long after an invoice payment is due. Every side of the ledger settles on the same terms — a vendor is bought
 * from on one of these, a customer is sold to on one, and a contractor is paid on one — so the list lives in a module
 * of its own, which the party kinds and a person's contracts all import and which imports nothing of theirs.
 */
export const PAYMENT_TERMS = ["on-receipt", "net-15", "net-30", "net-45", "net-60", "net-90"] as const;
export type PaymentTerm = (typeof PAYMENT_TERMS)[number];

export const PAYMENT_TERM_LABELS: Readonly<Record<PaymentTerm, string>> = {
	"on-receipt": "On receipt",
	"net-15": "Net 15",
	"net-30": "Net 30",
	"net-45": "Net 45",
	"net-60": "Net 60",
	"net-90": "Net 90",
};

/**
 * The payment terms a vendor, a customer or a contractor is dealt with on, refused in the words the form shows when
 * none is chosen: every kind takes this one schema, so they all say the same thing about it.
 */
export const paymentTermsSchema = z.enum(PAYMENT_TERMS, "Choose payment terms");
